import { AfterViewInit, Component, ElementRef, Input, OnChanges, Renderer2, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TypedChanges } from '@platform-frontend/util';
import { icoError } from '../../icons';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../../ui-tools-transloco-scope';
import { StaticErrorSpecification } from '../error-specification/static-error-specification';
import { TranslocoErrorSpecification } from '../error-specification/transloco-error-specification';

@Component({
  selector: 'yat-error-outlet',
  templateUrl: './error-outlet.component.html',
  styleUrls: ['./error-outlet.component.scss']
})
export class ErrorOutletComponent implements OnChanges, AfterViewInit {
  constructor(private renderer: Renderer2, private translocoService: TranslocoService) {}

  @ViewChild('defaultBtn', { read: ElementRef })
  defaultBtn: ElementRef<HTMLButtonElement>;

  @Input()
  errorSpecification?: TranslocoErrorSpecification | StaticErrorSpecification;

  spec: Required<TranslocoErrorSpecification | StaticErrorSpecification> = this.completeSpec();
  private unregisterCallback: () => void = () => undefined;

  ngOnChanges(changes: TypedChanges<ErrorOutletComponent>): void {
    if (changes.errorSpecification) {
      this.spec = this.completeSpec(this.errorSpecification);
      this.updateClickHandler();
    }
  }

  private completeSpec(spec?: TranslocoErrorSpecification | StaticErrorSpecification): Required<TranslocoErrorSpecification | StaticErrorSpecification> {
    return spec?.type === 'static'
      ? {
          type: 'static',
          description: spec.description,
          icon: spec?.icon ?? icoError,
          title: spec.title,
          buttonName: spec.buttonName,
          buttonClick: spec?.buttonClick ?? null
        }
      : {
          type: 'transloco',
          descriptions: spec?.descriptions ?? [{ key: 'uiTools.errorSpecification.defaultDescription', scope: UI_TOOLS_TRANSLOCO_SCOPE }],
          icon: spec?.icon ?? icoError,
          title: spec?.title ?? this.translocoService.selectTranslate('errorSpecification.defaultTitle', {}, UI_TOOLS_TRANSLOCO_SCOPE),
          buttonName: spec?.buttonName ?? null,
          buttonClick: spec?.buttonClick ?? null,
          forErrorTypes: spec?.forErrorTypes ?? []
        };
  }

  ngAfterViewInit(): void {
    this.updateClickHandler();
  }

  private updateClickHandler(): void {
    if (!this.defaultBtn?.nativeElement) {
      return;
    }

    this.unregisterCallback();
    this.renderer.removeAttribute(this.defaultBtn.nativeElement, 'onclick');

    if (typeof this.spec.buttonClick === 'string') {
      this.renderer.setAttribute(this.defaultBtn.nativeElement, 'onclick', this.spec.buttonClick);
    } else if (typeof this.spec.buttonClick === 'function') {
      const callback = this.spec.buttonClick;
      this.unregisterCallback = this.renderer.listen(this.defaultBtn.nativeElement, 'click', () => callback());
    }
  }
}
